import React from "react";
import { MapStateToPropsParam } from "react-redux";

import { counsellingsTopicUrl } from "@/mk2/apps/counsellings/urls";
import PostDetailPage, {
    OwnProps,
    PostDetailViewType,
    Props,
    RouteProps,
    StateProps,
} from "@/mk2/apps/forum/containers/PostDetail/PostDetailPage";
import { breadcrumbsCounsellings, discussionForumPosting } from "@/mk2/apps/forum/structuredData";
import { url } from "@/mk2/helpers/urls";
import { AppState } from "@/mk2/reducers";

export default class CounsellingsPostDetailPage extends PostDetailPage {
    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {
                ...(super.mapStateToProps()(state, ownProps) as StateProps),
                viewType: PostDetailViewType.AskAnExpert,
            };
        };
    }

    public getStructuredData(props: Props): object[] {
        const { post, baseUrl, comments } = props;
        if (post) {
            const topic = post.topic ? post.topic : null;
            return [
                breadcrumbsCounsellings(baseUrl, topic, post),
                discussionForumPosting(baseUrl, post, comments),
            ];
        }
    }

    public getDefaultBackPath(props: Props): string {
        const {
            routeParams: { topicSlug },
        } = props;
        return url(counsellingsTopicUrl, { topicSlug });
    }
}
